"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _customerOrderApi = require("@/api/customerOrderApi");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MerchantForm',
  props: {
    merchantId: {
      type: [String, Number],
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    dataSource: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isDisabled: this.isEdit && this.merchantId && this.dataSource === '接口',
      currentStep: 1,
      submitting: false,
      companyOptions: [],
      companyLoading: false,
      payChannelOptions: [],
      extraList: [],
      invoiceMethodOptions: [{
        value: '1',
        label: '无票'
      }, {
        value: '2',
        label: '普票'
      }, {
        value: '3',
        label: '专票'
      }, {
        value: '4',
        label: '混合票种'
      }],
      cooperationStatusOptions: [{
        value: '1',
        label: '待联系'
      }, {
        value: '2',
        label: '初次联系无回复'
      }, {
        value: '3',
        label: '资料收集'
      }, {
        value: '4',
        label: '商务洽谈'
      }, {
        value: '5',
        label: '签订合同'
      }, {
        value: '6',
        label: '合同终止'
      }],
      adjustTypeOptions: [{
        value: 1,
        label: '不超过原价'
      }, {
        value: 2,
        label: '不限制'
      }],
      maintainerOptions: [],
      otherDocumentsList: [],
      uploading: false,
      customerOptions: [],
      customerLoading: false,
      localFormData: {
        company: '',
        relatedCustomerType: 1,
        customerIds: [],
        merchantName: '',
        //接口禁止修改
        loginAccount: '',
        loginPassword: '',
        cooperationStatus: '5',
        invoiceMethod: '',
        maintainer: '',
        contactPeMerchanton: '',
        //接口禁止修改
        contactPhone: '',
        //接口禁止修改
        wechatGroupName: '',
        address: '',
        //接口禁止修改
        socialCreditCode: '',
        //接口禁止修改
        remark: '',
        isAdjust: 0,
        // 调价方式：0-不调价，1-按比例
        adjustType: '',
        // 调价范围：1-不超过原价，2-不限制
        adjustRate: '',
        // 调价比例（前端显示百分比，后端存储小数）
        paymentMerchantType: 0,
        payChannel: '',
        merchantNo: '',
        merchantKey: '',
        publicMerchantKey: '',
        payChannelPublicKey: '',
        certSerialNo: '',
        certPath: '',
        extraConfig: '{}'
      },
      basicRules: {
        company: [{
          required: true,
          message: '请选择归属公司',
          trigger: 'change'
        }],
        relatedCustomerType: [{
          required: true,
          message: '请选择关联小程序客户范围',
          trigger: 'change'
        }],
        customerIds: [{
          validator: this.validateCustomerIds,
          trigger: 'change'
        }],
        merchantName: [{
          required: true,
          message: '请输入供应商名称',
          trigger: 'blur'
        }, {
          min: 2,
          max: 50,
          message: '供应商名称长度在 2 到 50 个字符',
          trigger: 'blur'
        }],
        loginAccount: [{
          min: 3,
          max: 20,
          message: '登录账号长度在 3 到 20 个字符',
          trigger: 'blur'
        }],
        loginPassword: [{
          min: 6,
          max: 20,
          message: '密码长度在 6 到 20 个字符',
          trigger: 'blur'
        }],
        cooperationStatus: [{
          required: true,
          message: '请选择合作状态',
          trigger: 'change'
        }],
        contactPhone: [{
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号码',
          trigger: 'blur'
        }],
        // socialCreditCode: [
        //   { pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/, message: '请输入正确的统一社会信用代码', trigger: 'blur' }
        // ],
        adjustType: [{
          validator: this.validateAdjustType,
          trigger: 'change'
        }],
        adjustRate: [{
          validator: this.validateAdjustRate,
          trigger: 'blur'
        }],
        payChannel: [{
          validator: this.validateMerchantPayField,
          trigger: 'change'
        }],
        merchantNo: [{
          validator: this.validateMerchantPayField,
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    currentFormData: function currentFormData() {
      return _objectSpread(_objectSpread({}, this.localFormData), this.formData);
    }
  },
  watch: {
    isEdit: {
      handler: function handler(newVal) {
        if (!newVal) {
          // 切换到新增模式时，清空账号密码
          this.localFormData.loginAccount = '';
          this.localFormData.loginPassword = '';
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    // 初始化时加载公司选项和维护人选项
    this.loadCompanyOptions();
    this.loadMaintainerOptions();
    this.loadPayChannelOptions();
    this.searchCustomerOptions('');

    // 如果是编辑模式且有merchantId，加载详情数据
    if (this.isEdit && this.merchantId) {
      this.loadMerchantDetail();
    }
  },
  methods: {
    // 加载商户详情数据
    loadMerchantDetail: function loadMerchantDetail() {
      var _this = this;
      if (!this.merchantId) return;
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/rsApi'));
      }).then(function (_ref) {
        var getSupplierDetail = _ref.getSupplierDetail;
        getSupplierDetail(_this.merchantId).then(function (response) {
          // 将详情数据赋值给localFormData
          console.log('response', response);
          _this.localFormData = _objectSpread(_objectSpread(_objectSpread({}, _this.localFormData), response), {}, {
            // 编辑模式下清空登录密码
            loginPassword: '',
            // 处理调价比例：后端存储小数，前端也直接使用小数
            adjustRate: response.adjustRate ? Number(response.adjustRate).toFixed(2) : '',
            paymentMerchantType: _this.getPaymentMerchantType(response),
            relatedCustomerType: _this.parseRelatedCustomerType(response),
            customerIds: _this.parseCustomerIds(response)
          });
          _this.mergeCustomerOptionsFromDetail(response);
          _this.extraList = _this.parseExtraConfig(response.extraConfig);

          // 处理其他证件列表的回显
          if (response.otherDocuments && Array.isArray(response.otherDocuments)) {
            _this.otherDocumentsList = response.otherDocuments.map(function (url, index) {
              return {
                name: "\u8BC1\u4EF6".concat(index + 1),
                url: url,
                uid: Date.now() + index
              };
            });
          }

          // 确保下拉选项包含当前值
          _this.$nextTick(function () {
            if (response.company) {
              _this.ensureCurrentCompanyInOptions();
            }
            if (response.maintainer) {
              _this.ensureCurrentMaintainerInOptions();
            }

            // 处理合作状态回显（根据枚举值）
            if (response.cooperationStatus) {
              _this.ensureCooperationStatusInOptions(response.cooperationStatus);
            }
          });
        }).catch(function (error) {
          console.error('获取商户详情失败:', error);
          _this.$message.error(error.message || '获取商户详情失败');
        });
      });
    },
    searchCustomerOptions: function () {
      var _searchCustomerOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(keyword) {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.customerLoading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _customerOrderApi.companyappAutoListApi)({
                keyword: keyword
              });
            case 2:
              res = _context.v;
              this.customerOptions = res || [];
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.warn('获取小程序客户列表失败:', _t.message);
              if (!this.customerOptions.length) {
                this.customerOptions = [];
              }
            case 4:
              _context.p = 4;
              this.customerLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function searchCustomerOptions(_x) {
        return _searchCustomerOptions.apply(this, arguments);
      }
      return searchCustomerOptions;
    }(),
    onRelatedCustomerTypeChange: function onRelatedCustomerTypeChange(val) {
      var _this2 = this;
      if (Number(val) === 1) {
        this.localFormData.customerIds = [];
      }
      this.$nextTick(function () {
        _this2.$refs.basicForm && _this2.$refs.basicForm.clearValidate(['customerIds']);
      });
    },
    parseRelatedCustomerType: function parseRelatedCustomerType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var rawType = data.relatedCustomerType;
      if (rawType != null && rawType !== '' && !Number.isNaN(Number(rawType))) {
        return Number(rawType) === 1 ? 1 : 0;
      }
      if (Array.isArray(data.customerIds) && data.customerIds.length) {
        return 0;
      }
      return 1;
    },
    parseCustomerIds: function parseCustomerIds() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this.parseRelatedCustomerType(data) !== 0) {
        return [];
      }
      if (!Array.isArray(data.customerIds)) {
        return [];
      }
      return data.customerIds.map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return !Number.isNaN(id);
      });
    },
    mergeCustomerOptionsFromDetail: function mergeCustomerOptionsFromDetail() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var byId = new Map((this.customerOptions || []).map(function (item) {
        return [Number(item.customerId), item];
      }));
      var namedList = data.applyCustomerList || data.customerList || [];
      var idsFromDetail = Array.isArray(data.customerIds) ? data.customerIds : [];
      if (Array.isArray(namedList) && namedList.length) {
        namedList.forEach(function (row) {
          var customerId = Number(row.customerId != null ? row.customerId : row.id);
          if (Number.isNaN(customerId)) return;
          byId.set(customerId, {
            customerId: customerId,
            appName: row.appName || row.name || row.customerName || "\u5BA2\u6237 ".concat(customerId)
          });
        });
      } else if (idsFromDetail.length) {
        idsFromDetail.forEach(function (id) {
          var customerId = Number(id);
          if (Number.isNaN(customerId) || byId.has(customerId)) return;
          byId.set(customerId, {
            customerId: customerId,
            appName: "\u5BA2\u6237 ".concat(customerId)
          });
        });
      }
      this.customerOptions = Array.from(byId.values());
    },
    validateCustomerIds: function validateCustomerIds(rule, value, callback) {
      if (Number(this.localFormData.relatedCustomerType) === 0) {
        if (!value || !value.length) {
          callback(new Error('请选择关联小程序'));
          return;
        }
      }
      callback();
    },
    loadPayChannelOptions: function () {
      var _loadPayChannelOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$import, getPayChannelOption, res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return Promise.resolve().then(function () {
                return _interopRequireWildcard(require('@/api/payChannel'));
              });
            case 1:
              _yield$import = _context2.v;
              getPayChannelOption = _yield$import.getPayChannelOption;
              _context2.n = 2;
              return getPayChannelOption();
            case 2:
              res = _context2.v;
              this.payChannelOptions = res || [];
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.warn('获取支付通道选项失败:', _t2.message);
              this.payChannelOptions = [];
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 3]]);
      }));
      function loadPayChannelOptions() {
        return _loadPayChannelOptions.apply(this, arguments);
      }
      return loadPayChannelOptions;
    }(),
    hasMerchantPayConfig: function hasMerchantPayConfig() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Boolean(data.payChannel || data.merchantNo || data.merchantKey || data.publicMerchantKey || data.payChannelPublicKey || data.certSerialNo || data.certPath);
    },
    getPaymentMerchantType: function getPaymentMerchantType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (data.paymentMerchantType === 0 || data.paymentMerchantType === 1) {
        return data.paymentMerchantType;
      }
      return this.hasMerchantPayConfig(data) ? 1 : 0;
    },
    resetPayChannelFields: function resetPayChannelFields() {
      this.localFormData.payChannel = '';
      this.localFormData.merchantNo = '';
      this.localFormData.merchantKey = '';
      this.localFormData.publicMerchantKey = '';
      this.localFormData.payChannelPublicKey = '';
      this.localFormData.certSerialNo = '';
      this.localFormData.certPath = '';
      this.localFormData.extraConfig = '{}';
      this.extraList = [];
    },
    handlePaymentMerchantTypeChange: function handlePaymentMerchantTypeChange(value) {
      var _this3 = this;
      if (value === 0) {
        this.resetPayChannelFields();
      }
      this.$nextTick(function () {
        _this3.$refs.basicForm && _this3.$refs.basicForm.clearValidate(['payChannel', 'merchantNo']);
      });
    },
    parseExtraConfig: function parseExtraConfig(extraConfig) {
      if (!extraConfig) return [];
      try {
        var obj = typeof extraConfig === 'string' ? JSON.parse(extraConfig) : extraConfig;
        return Object.keys(obj || {}).map(function (key) {
          return {
            key: key,
            value: obj[key]
          };
        });
      } catch (error) {
        console.warn('解析扩展配置失败:', error.message);
        return [];
      }
    },
    addExtra: function addExtra() {
      this.extraList.push({
        key: '',
        value: ''
      });
    },
    removeExtra: function removeExtra(index) {
      this.extraList.splice(index, 1);
    },
    buildExtraConfig: function buildExtraConfig() {
      var obj = {};
      this.extraList.forEach(function (item) {
        if (item.key) {
          obj[item.key] = item.value;
        }
      });
      this.localFormData.extraConfig = JSON.stringify(obj);
    },
    // 加载公司选项
    loadCompanyOptions: function loadCompanyOptions() {
      var _this4 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // 如果没有关键词且已有数据，不重新加载
      if (!keyword && this.companyOptions.length > 0) {
        return;
      }
      if (this.companyLoading) return;
      this.companyLoading = true;
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/suplierCouponsApi'));
      }).then(function (_ref2) {
        var getAllCompany = _ref2.getAllCompany;
        getAllCompany(keyword).then(function (res) {
          _this4.companyOptions = res || [];

          // 如果是编辑模式且有公司ID，需要确保当前公司在选项中
          if (_this4.isEdit && _this4.localFormData.company && !_this4.companyOptions.find(function (item) {
            return item.id === _this4.localFormData.company;
          })) {
            // 如果当前公司不在选项中，需要获取公司信息并添加到选项中
            _this4.ensureCurrentCompanyInOptions();
          }
        }).catch(function (error) {
          console.warn('获取公司选项失败:', error.message);
          // 出错时不清空现有数据，避免闪烁
          if (_this4.companyOptions.length === 0) {
            _this4.companyOptions = [];
          }
        }).finally(function () {
          _this4.companyLoading = false;
        });
      });
    },
    // 确保当前公司在选项中（用于编辑模式）
    ensureCurrentCompanyInOptions: function ensureCurrentCompanyInOptions() {
      var _this5 = this;
      if (this.isEdit && this.localFormData.company) {
        // 检查当前公司是否已在选项中
        var existingCompany = this.companyOptions.find(function (item) {
          return item.id === _this5.localFormData.company;
        });
        if (!existingCompany) {
          // 如果有公司名称，直接添加到选项中
          if (this.localFormData.companyName) {
            var currentCompany = {
              id: this.localFormData.company,
              name: this.localFormData.companyName
            };
            this.companyOptions.unshift(currentCompany);
          } else {
            // 如果没有公司名称，通过API获取
            this.fetchCompanyNameById(this.localFormData.company);
          }
        }
      }
    },
    // 根据ID获取公司名称
    fetchCompanyNameById: function fetchCompanyNameById(companyId) {
      var _this6 = this;
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/suplierCouponsApi'));
      }).then(function (_ref3) {
        var getAllCompany = _ref3.getAllCompany;
        getAllCompany('').then(function (res) {
          var company = (res || []).find(function (item) {
            return item.id === companyId;
          });
          if (company && !_this6.companyOptions.find(function (item) {
            return item.id === companyId;
          })) {
            _this6.companyOptions.unshift(company);
          }
        }).catch(function (error) {
          console.warn('获取公司信息失败:', error.message);
        });
      });
    },
    // 处理公司搜索
    handleCompanySearch: function handleCompanySearch(keyword) {
      var _this7 = this;
      // 如果没有关键词，显示所有已加载的选项
      if (!keyword) {
        return true;
      }

      // 如果还没有加载过数据，先加载
      if (this.companyOptions.length === 0) {
        this.loadCompanyOptions('');
      }

      // 使用throttle调用API搜索
      if (keyword) {
        (0, _throttle.default)(function () {
          _this7.loadCompanyOptions(keyword);
        }, 300)();
      }

      // 返回true让Element UI进行本地过滤
      return true;
    },
    // 加载维护人选项 - 参考供应商页面的实现
    loadMaintainerOptions: function loadMaintainerOptions() {
      var _this8 = this;
      var keyWord = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // 如果没有关键词且已有数据，不重新加载
      if (!keyWord && this.maintainerOptions.length > 0) {
        return;
      }
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/suplierCouponsApi'));
      }).then(function (_ref4) {
        var getAllUser = _ref4.getAllUser;
        getAllUser(keyWord).then(function (res) {
          _this8.maintainerOptions = res || []; // flag: 1表示当前登陆人

          // 如果是编辑模式且有维护人ID，需要确保当前维护人在选项中
          if (_this8.isEdit && _this8.localFormData.maintainer) {
            _this8.ensureCurrentMaintainerInOptions();
          }
        }).catch(function (error) {
          console.warn('获取维护人选项失败:', error.message);
          // 出错时不清空现有数据，避免闪烁
          if (_this8.maintainerOptions.length === 0) {
            _this8.maintainerOptions = [];
          }
        });
      });
    },
    // 确保当前维护人在选项中（用于编辑模式）
    ensureCurrentMaintainerInOptions: function ensureCurrentMaintainerInOptions() {
      var _this9 = this;
      if (this.isEdit && this.localFormData.maintainer) {
        // 检查当前维护人是否已在选项中
        var existingMaintainer = this.maintainerOptions.find(function (item) {
          return item.id === _this9.localFormData.maintainer;
        });
        if (!existingMaintainer) {
          // 如果有维护人名称，直接添加到选项中
          if (this.localFormData.maintainerName) {
            var currentMaintainer = {
              id: this.localFormData.maintainer,
              realName: this.localFormData.maintainerName,
              flag: 0
            };
            this.maintainerOptions.unshift(currentMaintainer);
          } else {
            // 如果没有维护人名称，通过API获取
            this.fetchMaintainerNameById(this.localFormData.maintainer);
          }
        }
      }
    },
    // 根据ID获取维护人名称
    fetchMaintainerNameById: function fetchMaintainerNameById(maintainerId) {
      var _this0 = this;
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/suplierCouponsApi'));
      }).then(function (_ref5) {
        var getAllUser = _ref5.getAllUser;
        getAllUser('').then(function (res) {
          var maintainer = (res || []).find(function (item) {
            return item.id === maintainerId;
          });
          if (maintainer && !_this0.maintainerOptions.find(function (item) {
            return item.id === maintainerId;
          })) {
            _this0.maintainerOptions.unshift(maintainer);
          }
        }).catch(function (error) {
          console.warn('获取维护人信息失败:', error.message);
        });
      });
    },
    // 确保合作状态在选项中（用于编辑时回显）
    ensureCooperationStatusInOptions: function ensureCooperationStatusInOptions(cooperationStatusId) {
      // 合作状态是硬编码的枚举，直接检查是否存在
      var existingStatus = this.cooperationStatusOptions.find(function (item) {
        return item.value === cooperationStatusId;
      });
      if (!existingStatus) {
        console.warn("\u672A\u627E\u5230\u503C\u4E3A".concat(cooperationStatusId, "\u7684\u5408\u4F5C\u72B6\u6001"));
      } else {
        console.log("\u627E\u5230\u5408\u4F5C\u72B6\u6001: ".concat(existingStatus.label));
      }
    },
    // 处理维护人搜索
    handleMaintainerSearch: function handleMaintainerSearch(keyword) {
      var _this1 = this;
      // 如果没有关键词，显示所有已加载的选项
      if (!keyword) {
        return true;
      }

      // 如果还没有加载过数据，先加载
      if (this.maintainerOptions.length === 0) {
        this.loadMaintainerOptions('');
      }

      // 使用throttle调用API搜索
      if (keyword) {
        (0, _throttle.default)(function () {
          _this1.loadMaintainerOptions(keyword);
        }, 300)();
      }

      // 返回true让Element UI进行本地过滤
      return true;
    },
    // 下一步
    nextStep: function nextStep() {
      var _this10 = this;
      this.$refs.basicForm.validate(function (valid) {
        if (valid) {
          _this10.currentStep++;
        }
      });
    },
    // 上一步
    prevStep: function prevStep() {
      this.currentStep--;
    },
    // logo上传前验证
    beforeLogoUpload: function beforeLogoUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    // 处理logo上传
    handleLogoUpload: function handleLogoUpload(options) {
      var _this11 = this;
      var formData = new FormData();
      formData.append('multipart', options.file);

      // 设置上传参数
      var params = {
        model: 'merchant',
        pid: 1
      };
      this.uploading = true;
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/systemSetting'));
      }).then(function (_ref6) {
        var fileImageApi = _ref6.fileImageApi;
        fileImageApi(formData, params).then(function (response) {
          // 获取接口返回的图片URL
          _this11.localFormData.logo = response.url || response;
          _this11.$message.success('logo上传成功');
        }).catch(function (error) {
          _this11.$message.error(error.message || 'logo上传失败');
        }).finally(function () {
          _this11.uploading = false;
        });
      });
    },
    // 营业执照上传前验证
    beforeLicenseUpload: function beforeLicenseUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    // 处理营业执照上传
    handleLicenseUpload: function handleLicenseUpload(options) {
      var _this12 = this;
      var formData = new FormData();
      formData.append('multipart', options.file);

      // 设置上传参数
      var params = {
        model: 'merchant',
        pid: 1
      };
      this.uploading = true;
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/systemSetting'));
      }).then(function (_ref7) {
        var fileImageApi = _ref7.fileImageApi;
        fileImageApi(formData, params).then(function (response) {
          // 获取接口返回的图片URL
          _this12.localFormData.businessLicense = response.url || response;
          _this12.$message.success('营业执照上传成功');
        }).catch(function (error) {
          _this12.$message.error(error.message || '营业执照上传失败');
        }).finally(function () {
          _this12.uploading = false;
        });
      });
    },
    // 其他证件上传前验证
    beforeDocumentsUpload: function beforeDocumentsUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    // 处理其他证件上传
    handleDocumentsUpload: function handleDocumentsUpload(options) {
      var _this13 = this;
      var formData = new FormData();
      formData.append('multipart', options.file);

      // 设置上传参数
      var params = {
        model: 'merchant',
        pid: 1
      };
      this.uploading = true;
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/systemSetting'));
      }).then(function (_ref8) {
        var fileImageApi = _ref8.fileImageApi;
        fileImageApi(formData, params).then(function (response) {
          // 添加到文件列表
          var fileUrl = response.url || response;
          _this13.otherDocumentsList.push({
            name: options.file.name,
            url: fileUrl,
            uid: Date.now() + Math.random()
          });

          // 更新表单数据
          _this13.localFormData.otherDocuments = _this13.otherDocumentsList.map(function (item) {
            return item.url;
          });
          _this13.$message.success('证件上传成功');
        }).catch(function (error) {
          _this13.$message.error(error.message || '证件上传失败');
        }).finally(function () {
          _this13.uploading = false;
        });
      });
    },
    // 移除其他证件
    handleDocumentRemove: function handleDocumentRemove(file) {
      var index = this.otherDocumentsList.findIndex(function (item) {
        return item.uid === file.uid;
      });
      if (index > -1) {
        this.otherDocumentsList.splice(index, 1);
        this.localFormData.otherDocuments = this.otherDocumentsList.map(function (item) {
          return item.url;
        });
      }
    },
    // 处理调价方式变化
    handleAdjustTypeChange: function handleAdjustTypeChange(value) {
      if (value === 0) {
        // 不调价时清空调价范围和调价比例
        this.localFormData.adjustType = '';
        this.localFormData.adjustRate = '';
      }
    },
    // 处理调价比例输入
    handleAdjustRateInput: function handleAdjustRateInput(value) {
      // 确保输入值是数字
      if (value !== '' && value !== null && value !== undefined) {
        var numValue = Number(value);
        if (!isNaN(numValue)) {
          // 限制在-1到1之间
          if (numValue < -1) {
            this.localFormData.adjustRate = -1;
          } else if (numValue > 1) {
            this.localFormData.adjustRate = 1;
          } else {
            // 保留两位小数
            this.localFormData.adjustRate = Math.round(numValue * 100) / 100;
          }
        }
      }
    },
    // 验证调价范围
    validateAdjustType: function validateAdjustType(rule, value, callback) {
      // 只有选择按比例调价时才需要验证调价范围
      if (this.localFormData.isAdjust === 1) {
        if (!value || value === '') {
          callback(new Error('请选择调价范围'));
          return;
        }
      }
      callback();
    },
    // 验证调价比例
    validateAdjustRate: function validateAdjustRate(rule, value, callback) {
      // 只有选择按比例调价时才需要验证调价比例
      if (this.localFormData.isAdjust === 1) {
        if (value === '' || value === null || value === undefined) {
          callback(new Error('请输入调价比例'));
          return;
        }
        var numValue = Number(value);
        if (isNaN(numValue)) {
          callback(new Error('请输入有效的数字'));
          return;
        }
        if (numValue < -1 || numValue > 1) {
          callback(new Error('调价比例必须在-1到1之间'));
          return;
        }
      }
      callback();
    },
    validateMerchantPayField: function validateMerchantPayField(rule, value, callback) {
      if (this.localFormData.paymentMerchantType !== 1) {
        callback();
        return;
      }
      if (rule.field === 'payChannel' && !value) {
        callback(new Error('请选择支付通道'));
        return;
      }
      if (rule.field === 'merchantNo' && !value) {
        callback(new Error('请输入商户号'));
        return;
      }
      callback();
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this14 = this;
      // 只验证基本表单，因为第二步已经被注释掉了
      this.$refs['basicForm'].validate(function (valid) {
        if (valid) {
          // 直接提交数据，因为第二步已经被注释掉了
          _this14.submitting = true;

          // 调用后端API
          var apiMethod = _this14.isEdit ? 'updateSupplier' : 'addSupplier';
          var submitData = _objectSpread({}, _this14.localFormData);
          delete submitData.memberDiscount;
          var relatedCustomerType = Number(submitData.relatedCustomerType) === 1 ? 1 : 0;
          submitData.relatedCustomerType = relatedCustomerType;
          submitData.customerIds = relatedCustomerType === 0 && submitData.customerIds && submitData.customerIds.length ? submitData.customerIds.map(function (id) {
            return Number(id);
          }) : [];

          // 调价比例：前端和后端都使用小数，无需转换
          _this14.buildExtraConfig();
          submitData.extraConfig = _this14.localFormData.extraConfig;
          if (submitData.paymentMerchantType !== 1) {
            submitData.payChannel = '';
            submitData.merchantNo = '';
            submitData.merchantKey = '';
            submitData.publicMerchantKey = '';
            submitData.payChannelPublicKey = '';
            submitData.certSerialNo = '';
            submitData.certPath = '';
            submitData.extraConfig = '{}';
          }

          // delete submitData.paymentMerchantType

          // 如果是编辑模式，确保包含ID
          if (_this14.isEdit && _this14.merchantId) {
            submitData.id = _this14.merchantId;
          }

          // 处理其他证件列表字段
          if (submitData.otherDocuments && Array.isArray(submitData.otherDocuments)) {
            submitData.otherDocumentsList = submitData.otherDocuments.map(function (doc) {
              return doc.url || doc;
            });
            delete submitData.otherDocuments;
          }
          Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@/api/rsApi'));
          }).then(function (_ref9) {
            var apiFunc = _ref9[apiMethod];
            apiFunc(submitData).then(function (data) {
              // request拦截器已处理响应结构，直接使用data
              _this14.$message.success(_this14.isEdit ? '更新成功' : '新增成功');
              _this14.$emit('save', data);
              _this14.submitting = false;
            }).catch(function (error) {
              _this14.$message.error(error.message || (_this14.isEdit ? '更新失败' : '新增失败'));
              _this14.submitting = false;
            });
          });
        } else {
          _this14.$message.warning('请完善必填信息');
        }
      });
    },
    // 取消
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};